import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { selectEntitiesByFilters } from "../../../../shared/store/views/entityView";
import { realisticIsraelFilters } from "../../../../shared/utils/entitiesFiltersUtils";
import realisticCoursesImg from '../../../../assests/realisticIsrael/noCoursesAvailable.png';
import MyCourseItem from "../../../../shared/components/features/courseItem/myCourseItem/MyCourseItem";
import Widget from "../../../../shared/components/features/widget/Widget";
import iconsList from "../../../../shared/components/ui/icons/iconsList";
import classes from "./RealisticIsraelCoursesWidget.module.css";

const RealisticIsraelCoursesWidget = () => {

    const { texts } = useSelector(state => state.translate);
    const realisticIsraelCourses = useSelector(state => selectEntitiesByFilters(state, realisticIsraelFilters));
    
    return (
        <Widget
            color="#FDDB71"
            title={`${texts.realisticIsrael ?? ""} ${texts.myStudyGroup ?? ""}`}
            icon={iconsList.myLearning}
            className={classes.RealisticIsraelCoursesWidget}
            contentScrollable={realisticIsraelCourses?.length > 0}
        >
            {realisticIsraelCourses?.length > 0 ? (
                <div className={classes.CoursesContent}>
                    <div className={classes.CoursesList}>
                        {realisticIsraelCourses.map((course, index) => (
                            <MyCourseItem
                                key={course.id || course.externalId || index}
                                course={course}
                            />
                        ))}
                    </div>
                </div>
            ) : (
                <div className={classes.CoursesList}>
                    <div className={classes.NoCourses}>
                        <img className={classes.NoCoursesImg} src={realisticCoursesImg} alt="" />
                        <p className={classes.NoCoursesText}>{texts.noRealisticCoursesAvailable}</p>
                    </div>
                </div>
            )}
        </Widget>
    );
};

export default RealisticIsraelCoursesWidget; 